/**
 * @generated SignedSource<<f86a715fbfdc4a4de6e0bf0853dcdc39>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type IntegrationTomraCreateScreenMutation$variables = {
  accountId: string;
  externalStoreId: string;
};
export type IntegrationTomraCreateScreenMutation$data = {
  readonly store: {
    readonly activateIntegrationTomra: {
      readonly __typename: "IntegrationTomra";
    } | null;
  };
};
export type IntegrationTomraCreateScreenMutation = {
  response: IntegrationTomraCreateScreenMutation$data;
  variables: IntegrationTomraCreateScreenMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "accountId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "externalStoreId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "accountId",
    "variableName": "accountId"
  },
  {
    "kind": "Variable",
    "name": "externalStoreId",
    "variableName": "externalStoreId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "IntegrationTomraCreateScreenMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "StoreMutations",
        "kind": "LinkedField",
        "name": "store",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "IntegrationTomra",
            "kind": "LinkedField",
            "name": "activateIntegrationTomra",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "IntegrationTomraCreateScreenMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "StoreMutations",
        "kind": "LinkedField",
        "name": "store",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "IntegrationTomra",
            "kind": "LinkedField",
            "name": "activateIntegrationTomra",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "5dd1dab75a1c1a219638bc0c87af70e3",
    "id": null,
    "metadata": {},
    "name": "IntegrationTomraCreateScreenMutation",
    "operationKind": "mutation",
    "text": "mutation IntegrationTomraCreateScreenMutation(\n  $accountId: String!\n  $externalStoreId: String!\n) {\n  store {\n    activateIntegrationTomra(accountId: $accountId, externalStoreId: $externalStoreId) {\n      __typename\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "0182856f77826320c7ea7e6623e331ed";

export default node;
